export default __webpack_public_path__ + "static/media/preview.415e5bf0.svg";